// Global Imports
import React from "react";

const Title = (props) => {
    return (
        <>
            <div className="w-full self-start flex flex-col md:flex-row md:items-center gap-2 mb-6 justify-between">
                <div
                    className="text-3xl font-bold"
                    style={{ color: "#ad2831" }}
                >
                    {props.title}
                </div>
            </div>
        </>

    );
}

export default Title;